const GIFT_VARIANT_ID = 53304832000333;
const GIFT_QUANTITY = 1;

// Don't run in theme editor
if (window.Shopify && window.Shopify.designMode) {
  console.log('Gift script disabled in theme editor');
} else {
  
  async function getCart() {
    try {
      const res = await fetch('/cart.js');
      return await res.json();
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null;
    }
  }

  async function addGift() {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: GIFT_VARIANT_ID,
          quantity: GIFT_QUANTITY
        })
      });
      
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      
      const data = await res.json();
      console.log('Gift added successfully:', data);
      return data;
    } catch (error) {
      console.error('Error adding gift:', error);
      return null;
    }
  }

  async function removeGift(lineIndex) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: lineIndex,
          quantity: 0
        })
      });
      
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      
      const data = await res.json();
      console.log('Gift removed successfully:', data);
      return data;
    } catch (error) {
      console.error('Error removing gift:', error);
      return null;
    }
  }

  async function handleGiftLogic() {
    console.log('🎁 Checking gift logic...');
    
    const cart = await getCart();
    if (!cart) {
      console.log('❌ Could not fetch cart');
      return;
    }

    console.log('📦 Cart items:', cart.item_count);

    let hasQualifyingProduct = false;
    let giftLineIndex = null;

    cart.items.forEach((item, index) => {
      if (item.variant_id === GIFT_VARIANT_ID) {
        giftLineIndex = index + 1;
        console.log('✅ Gift found at line:', giftLineIndex);
      } else {
        hasQualifyingProduct = true;
        console.log('📌 Qualifying product:', item.title);
      }
    });

    if (hasQualifyingProduct && !giftLineIndex) {
      console.log('➕ Adding gift to cart...');
      const result = await addGift();
      
      if (result) {
        // Refresh cart UI without full page reload
        if (document.querySelector('cart-drawer')) {
          // Trigger cart drawer refresh
          fetch(window.location.href)
            .then(res => res.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newCartDrawer = doc.querySelector('cart-drawer');
              if (newCartDrawer) {
                document.querySelector('cart-drawer').innerHTML = newCartDrawer.innerHTML;
              }
            });
        } else {
          // Fallback to page reload for non-drawer carts
          setTimeout(() => window.location.reload(), 300);
        }
      }
    } else if (!hasQualifyingProduct && giftLineIndex) {
      console.log('➖ Removing gift from cart...');
      const result = await removeGift(giftLineIndex);
      
      if (result) {
        if (document.querySelector('cart-drawer')) {
          fetch(window.location.href)
            .then(res => res.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newCartDrawer = doc.querySelector('cart-drawer');
              if (newCartDrawer) {
                document.querySelector('cart-drawer').innerHTML = newCartDrawer.innerHTML;
              }
            });
        } else {
          setTimeout(() => window.location.reload(), 300);
        }
      }
    } else {
      console.log('✓ Cart is correct, no changes needed');
    }
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleGiftLogic);
  } else {
    handleGiftLogic();
  }

  // Listen for cart changes
  document.addEventListener('cart:updated', () => {
    console.log('Cart updated event detected');
    setTimeout(handleGiftLogic, 100);
  });
}


